export const MESSAGES_ADD_ON_ID = 7; // 7 is id for messages add-on
export const MUSIC_MANAGEMENT_ADD_ON_ID = 10; // 10 is id for music-management add-on
